import ModuleWrapper from 'shared-lib/containers/Module';
/* eslint-disable max-len */
const TrafficSources = () => import(/* webpackChunkName: "trafficsources-default" */ '@/views/trafficSources/TrafficSources');
const TrafficSourcesDetails = () => import(/* webpackChunkName: "trafficsources-details" */ '@/views/trafficSources/TrafficSourcesDetails');
const TrafficSourcesDetailsTracking = () => import(/* webpackChunkName: "trafficsources-details-tracking" */ '@/views/trafficSources/TrafficSourcesDetailsTracking');
const AddTrafficSource = () => import(/* webpackChunkName: "trafficsources-add" */ '@/views/trafficSources/AddTrafficSource');
const EditTrafficSource = () => import(/* webpackChunkName: "trafficsources-edit" */ '@/views/trafficSources/EditTrafficSource');
const TrafficSourcesChangeOwner = () => import(/* webpackChunkName: "trafficsources-owner" */ '@/views/trafficSources/TrafficSourcesChangeOwner');
const TrafficSourceAddOffers = () => import(/* webpackChunkName: "traffic-source-offers" */ '@/views/trafficSources/TrafficSourceAddOffers');
const PostbackTesting = () => import(/* webpackChunkName: "postback-testing" */ '@/views/trafficSources/PostbackTesting');
const CampaignOffers = () => import(/* webpackChunkName: "offer-edit" */ '@/views/trafficSources/externalCostMapping/CampaignOffers');
/* eslint-enable max-len */

const meta = (data = {}) => ({
    permissionsModuleName: 'partners',
    title: 'Publishers',
    auth: true,
    ...data,
});


export default [{
    path: 'traffic-sources',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
    }),
    children: [
        {
            path: '',
            name: 'Publishers',
            component: TrafficSources,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: 'add',
            name: 'addTrafficSource',
            component: AddTrafficSource,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':partnerId(\\d+)/edit',
            name: 'EditTrafficSource',
            component: EditTrafficSource,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':partnerId(\\d+)/campaign-offers/:campaignId(\\d+)',
            name: 'CampaignOffers',
            component: CampaignOffers,
            props: true,
            meta: meta(),
        },
        {
            path: ':partnerId(\\d+)/change-owner',
            name: 'ChangeTrafficSourceOwner',
            component: TrafficSourcesChangeOwner,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':trafficSourceId(\\d+)/offers',
            name: 'TrafficSourceOffer',
            component: TrafficSourceAddOffers,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':partnerId(\\d+)',
            component: ModuleWrapper,
            props: true,
            meta: meta({
                permission: 'list',
            }),
            children: [
                {
                    path: '',
                    props: true,
                    name: 'TrafficSourceDetails',
                    component: TrafficSourcesDetails,
                    meta: meta({
                        permission: 'list',
                    }),
                },
                {
                    path: 'tracking/add',
                    name: 'TrafficSourceDetailsTrackingAdd',
                    component: TrafficSourcesDetailsTracking,
                    props: true,
                    meta: meta({
                        permission: 'update',
                    }),
                },
                {
                    path: 'tracking/:clicktagId(\\d+)/edit',
                    name: 'TrafficSourceDetailsTrackingEdit',
                    component: TrafficSourcesDetailsTracking,
                    props: true,
                    meta: meta({
                        permission: 'update',
                    }),
                },
            ],
        },
        {
            path: 'postback-testing',
            name: 'PostbackTesting',
            component: PostbackTesting,
            meta: {
                ...meta({
                    permission: 'list',
                }),
                customGuard: (store) => store?.getters?.isTestToolsEnabled,
            },
        },
    ],
}];
